import { createFileRoute } from '@tanstack/react-router';
import { DiscordDocsPage } from '@pages/discord-docs';

/** Discord-Bot-Dokumentation (/discord) */
export const Route = createFileRoute('/_authenticated/discord')({
  component: DiscordDocsPage,
});
